import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { useDispatch, useSelector } from "react-redux";
import { AlertCircle } from 'react-feather';
import { removeKeywords } from '../../store/actions/keywordActions';

const removeKeywordModal = ({keyword}) => {
  const dispatcher = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [keywordTitle, setKeywordTitle] = useState(null);
  const [keywordContent, setKeywordContent] = useState(true);
  const [isConfirmable, setIsConfirmable] = useState(true);
  const isLoading = useSelector((state) => state.config.disableButton);
  const keywordsObj = useSelector((state) => state.keywords);
  const currentDomain = useSelector((state) => state.domains.currentDomain);

  useEffect( () => {
    if (keyword) {
      setIsConfirmable(false);
      setKeywordTitle(`Are you sure you want to remove ${keyword.keyword} ?`);
      setKeywordContent(`Once confirm '${keyword.keyword}' will be permanently erased with rank history!`);
    } else if (keywordsObj.removals.length > 0)  {
      setIsConfirmable(false);
      setKeywordTitle(`Are you sure you want to remove ${keywordsObj.removals.length} keyword${ (keywordsObj.removals.length > 1) ? 's' : '' } ?`);
      setKeywordContent(`Once confirm ${keywordsObj.removals.length} keyword${ (keywordsObj.removals.length > 1) ? 's' : '' } will be permanently erased with rank history!`);
    } else {
      setKeywordTitle('Please select keywords to be removed.');
      setKeywordContent('By clicking on the checkboxes you can select keywords.')
    }
  }, [keywordsObj] );


  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    const keywordIds = (keyword) ? keyword._id : keywordsObj.removals.join(',');
    dispatcher(removeKeywords(currentDomain._id, keywordIds, setIsModalVisible, keywordsObj.pageNum, keywordsObj.search, keywordsObj.sort, keywordsObj.limit));
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <a style={{ color: 'darkred'  }} onClick={showModal}>
        Remove
      </a>
      <Modal
        title={keywordTitle}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Confirm"
        keyboard={false}
        maskClosable={false}
        okButtonProps={{
          disabled: isConfirmable,
          loading: isLoading,
          type: 'danger'
        }}
      >
        <p>
          <AlertCircle style={{ color: '#f5222d' }} /> {keywordContent}
        </p>
      </Modal>
    </>
  );
}

export default removeKeywordModal;